<div
  [ngClass]="{
    'detail-sidebar-container': pageType === 'sidebar',
    'detail-modal-container': pageType === 'modal'
  }">
  <div (click)="back()" class="back-icon">
    <i *ngIf="backArrow && pageType === 'sidebar'" nz-icon nzType="left" nzTheme="outline"></i>
  </div>

  <nz-tabset nzSize="large" [(nzSelectedIndex)]="activatedIndex" [class.side]="pageType === 'sidebar'">
    <nz-tab [nzTitle]="'order.basic_info' | translate" (nzSelect)="checkTab(0)">
      <ng-template nz-tab>
        <div class="content">
          <host-house-order-basic
            [orderDetail]="orderDetail"
            [pageType]="pageType"
            [loading]="loading"
            (refreshModal)="refreshModal($event)"
            (changeOrder)="changeOrder($event)"
            (onCreateHourOrder)="onCreateHourOrder($event)"
            (onToGuestPage)="activatedIndex = 2"></host-house-order-basic>
        </div>
      </ng-template>
    </nz-tab>
    <nz-tab [nzTitle]="'order.income_and_expenses' | translate" (nzSelect)="checkTab(1)">
      <div class="content">
        <host-house-order-finance
          [code]="orderDetail?.code"
          [list]="orderDetail?.income_and_expenses?.list"
          [currency]="orderDetail?.currency_type"
          [pageType]="pageType"
          (refreshModal)="refreshModal($event)"></host-house-order-finance>
      </div>
    </nz-tab>
    <nz-tab [nzTitle]="'order.guest' | translate" (nzSelect)="checkTab(2)">
      <ng-template nz-tab>
        <div class="content">
          <host-house-order-guest
            [code]="code"
            [pageType]="pageType"
            (refreshModal)="refreshModal($event)"></host-house-order-guest>
        </div>
      </ng-template>
    </nz-tab>

    <nz-tab [nzTitle]="'order_detail_html_tab_自动化' | translate">
      <ng-template nz-tab>
        <div class="content">
          <host-house-order-automation [code]="code" [pageType]="pageType"></host-house-order-automation>
        </div>
      </ng-template>
    </nz-tab>
  </nz-tabset>
</div>
